import { render, staticRenderFns } from "./Agreement18.vue?vue&type=template&id=4c742bf7&lang=pug&"
import script from "./Agreement18.vue?vue&type=script&lang=js&"
export * from "./Agreement18.vue?vue&type=script&lang=js&"
import style0 from "./Agreement18.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports